import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Icon } from '../../../../subcomponents/icon/icon';
import { MemberPhotoUploaderContextInstance } from '../types/context';
import { MemberPhotoUploaderFileForm } from './file-form';
const b = bemClassBuilder('v-member-photo-uploader-prompt');
export const MemberPhotoUploaderPrompt = observer(props => {
    const { onPhotoUploaded } = props;
    const { assets } = useContext(MemberPhotoUploaderContextInstance);
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(Icon, { className: b.element('examples'), name: assets.memberPhotoExamplesIcon.name, viewBox: assets.memberPhotoExamplesIcon.viewBox }), _jsx(MemberPhotoUploaderFileForm, { onPhotoUploaded: onPhotoUploaded, photoRequirements: props.photoRequirements })] })));
});
MemberPhotoUploaderPrompt.displayName = 'MemberPhotoUploaderPrompt';
